
export const required = value => value ? undefined : 'Campo requerido';

export const maxLength = max => value =>
    value && value.length > max ? `Must be ${max} characters or less` : undefined;